import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Icon from "../AppIcon";
import Button from "./Button";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navigationItems = [
    { name: "Home", path: "/hero-launch-pad", icon: "Home" },
    { name: "Projects", path: "/project-showcase-gallery", icon: "FolderOpen" },
    { name: "About", path: "/about-universe", icon: "User" },
    { name: "Skills", path: "/skills-laboratory", icon: "Code" },
    { name: "Experience", path: "/experience-timeline", icon: "Briefcase" },
  ];

  // const moreItems = [
  //   { name: 'Code Playground', path: '/code-playground', icon: 'Terminal' }
  // ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const isActivePath = (path) => location?.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-smooth ${
        isScrolled
          ? "bg-background/95 backdrop-blur-md border-b border-border shadow-subtle"
          : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-6 lg:px-8">
        {/* Logo */}
        <div
          className="flex items-center cursor-pointer group"
          onClick={() => handleNavigation("/hero-launch-pad")}
        >
          <div className="relative">
            <div className="w-10 h-10 bg-gradient-to-br from-conversion-accent to-trust-builder rounded-lg flex items-center justify-center transition-smooth group-hover:scale-105">
              <Icon name="Code2" size={20} color="white" strokeWidth={2.5} />
            </div>
            <div className="absolute -inset-1 bg-gradient-to-br from-conversion-accent/20 to-trust-builder/20 rounded-lg blur opacity-0 group-hover:opacity-100 transition-smooth" />
          </div>
          <div className="ml-3">
            <h1 className="text-xl font-bold font-mono text-foreground group-hover:text-conversion-accent transition-smooth">
              Yash Pal
            </h1>
            {/* <p className="text-xs text-muted-foreground font-mono">Pro</p> */}
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-1">
          {navigationItems?.map((item) => (
            <button
              key={item?.path}
              onClick={() => handleNavigation(item?.path)}
              className={`flex items-center px-4 py-2 rounded-lg text-sm font-medium transition-smooth hover:bg-muted/50 ${
                isActivePath(item?.path)
                  ? "text-conversion-accent bg-muted/30"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon name={item?.icon} size={16} className="mr-2" />
              {item?.name}
            </button>
          ))}

          {/* More Menu */}
          {/* <div className="relative group">
            <button className="flex items-center px-4 py-2 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-smooth">
              <Icon name="MoreHorizontal" size={16} className="mr-2" />
              More
            </button>
            
            <div className="absolute top-full right-0 mt-2 w-48 bg-popover border border-border rounded-lg shadow-strong opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-smooth">
              {moreItems?.map((item) => (
                <button
                  key={item?.path}
                  onClick={() => handleNavigation(item?.path)}
                  className={`flex items-center w-full px-4 py-3 text-sm text-left hover:bg-muted/50 transition-smooth first:rounded-t-lg last:rounded-b-lg ${
                    isActivePath(item?.path)
                      ? 'text-conversion-accent bg-muted/30' :'text-popover-foreground'
                  }`}
                >
                  <Icon name={item?.icon} size={16} className="mr-3" />
                  {item?.name}
                </button>
              ))}
            </div>
          </div> */}
        </nav>

        {/* CTA Button */}
        <div className="hidden lg:flex items-center space-x-4">
          <div className="flex items-center space-x-2 text-sm">
            <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
            <span className="text-muted-foreground">
              Available for projects
            </span>
          </div>

          <Link to="/contact">
            <Button
              variant="default"
              className="bg-cta hover:bg-cta/90 text-white font-semibold px-6"
              iconName="MessageCircle"
              iconPosition="left"
              iconSize={16}
            >
              Let's Connect
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="lg:hidden p-2 rounded-lg hover:bg-muted/50 transition-smooth"
        >
          <Icon name={isMenuOpen ? "X" : "Menu"} size={24} />
        </button>
      </div>
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-background/95 backdrop-blur-md border-b border-border">
          <nav className="px-6 py-4 space-y-2">
            {/* {[...navigationItems, ...moreItems]?.map((item) => ( */}
            {[...navigationItems]?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`flex items-center w-full px-4 py-3 rounded-lg text-sm font-medium transition-smooth ${
                  isActivePath(item?.path)
                    ? "text-conversion-accent bg-muted/30"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
                }`}
              >
                <Icon name={item?.icon} size={16} className="mr-3" />
                {item?.name}
              </button>
            ))}

            <div className="pt-4 border-t border-border">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2 text-sm">
                  <div className="w-2 h-2 bg-success rounded-full animate-pulse" />
                  <span className="text-muted-foreground">
                    Available for projects
                  </span>
                </div>
              </div>
              <Link to="/contact">
                <Button
                  variant="default"
                  fullWidth
                  className="bg-cta hover:bg-cta/90 text-white font-semibold"
                  iconName="MessageCircle"
                  iconPosition="left"
                  iconSize={16}
                >
                  Let's Connect
                </Button>
              </Link>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
